import { darkBlue } from 'src/styles/colors';
import styled from 'styled-components';

export const Header = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.pallete.backgrounds.modalHeader};
  padding: 15px;
  border-bottom: 1px solid ${darkBlue};
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`;

export const MvpDesignHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px 16px 0 16px;
`;

export const MvpNewDesignTitleContainer = styled.span`
  display: inline-block;
  font-size: 22px;
  font-weight: 500;
  color: ${darkBlue};
  width: 100%;
  text-align: center;
  font-style: normal;
  line-height: normal;
`;

export const TitleContainer = styled.span`
  display: inline-block;
  font-size: 1.2em;
  font-weight: ${({ theme }) => theme.typography.dialogHeader.fontWeight};
  color: ${darkBlue};
  width: 80%;
  text-align: left;
`;

export const CloseBtnContainer = styled.span`
  display: inline-block;
  width: 20%;
  text-align: right;
  font-size: 1.4em;
`;
